import { useQuery } from 'react-query';
import { locationApi } from '../../api';

const useGet = (id: number) => {
  const { isLoading, data } = useQuery(
    ['getLocation', id],
    () => {
      return locationApi.get(id);
    },
    {
      enabled: Boolean(id),
    }
  );
  return { isLoading, data };
};

export default useGet;
